import { api } from "api/api";
import { AxiosError } from "axios";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Deposito from "model/suprimentos/Deposito";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import PrevisaoConsumoMateriaPrimaFilter from "model/suprimentos/reports/PrevisaoConsumoMateriaPrimaFilter";
import { DataTableFilterMeta } from "primereact/datatable";
import { getFilters } from "utils/filterUtils";

class EstoqueService {

    pesquisar(page: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/estoque/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarInutilizavel(page: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/estoqueInutilizavel/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    relatorioNecessidadeCompra(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/estoque/relatorioNecessidadeCompra`;
            url += getFilters(filters)
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    ativarDesativar(estoqueLote: EstoqueLote) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/estoque/ativarDesativar`;

            api
                .put(url, JSON.stringify(estoqueLote))
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    familias() {
        return new Promise<Array<FamiliaProduto>>((resolve, reject): void => {
            api
                .get(`/estoque/familias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    origens() {
        return new Promise<Array<OrigemProduto>>((resolve, reject): void => {
            api
                .get(`/estoque/origens`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/estoque/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutosProduzidos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/estoque/produtosProduzidos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getDepositos() {
        return new Promise<Array<Deposito>>((resolve, reject): void => {
            api
                .get(`/estoque/depositos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioPrevisaoMateriaPrima(filters: PrevisaoConsumoMateriaPrimaFilter[]) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/estoque/report/previsaoConsumoMateriaPrima`;
            if (filters.length > 0) {
                url += `?filters=${encodeURIComponent(JSON.stringify(filters))}`;
            }
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }
}

export default EstoqueService;
